import React from "react";
import { Box, InputBaseComponentProps, TextField, Typography } from "@mui/material";
import { useStyles } from "./textbox.style";
import { Component, ErrorMessages } from "utils/constants";

interface TextBoxProps {
  id: string;
  label: string;
  labelId: string;
  svgLabelIcon?: React.ReactNode;
  type: string;
  className: string;
  rootClass?: string;
  labelClassName: string;
  autoComplete?: string;
  selectedValue: unknown;
  ariaLabelledBy: string;
  required: boolean;
  error?: boolean;
  errorMessage?: string | null;
  onChange: (value: string) => void;
  inputProps?: InputBaseComponentProps;
  onWheel?: (e: any) => void;
  multiline?: boolean;
  rows?: number;
  maxLength?: number;
}
export const TextBox: React.FC<TextBoxProps> = ({
  id,
  label,
  labelId,
  svgLabelIcon,
  type,
  className,
  rootClass,
  labelClassName,
  ariaLabelledBy,
  autoComplete,
  error,
  errorMessage,
  required,
  onChange,
  selectedValue,
  onWheel,
  inputProps,
  multiline,
  rows = 1,
  maxLength = 500,
}: TextBoxProps): React.ReactElement => {
  const classes = useStyles();
  return (
    <Box className={rootClass}>
      <Typography className={labelClassName}>
        {svgLabelIcon}
        <label id={labelId} htmlFor={id}>
          {label} {required && <span>*</span>}
        </label>
      </Typography>
      <TextField
        id={id}
        type={type}
        variant="outlined"
        required={required}
        className={className}
        autoComplete={autoComplete || "off"}
        size="small"
        value={selectedValue}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          onChange(event.target.value.trimStart());
        }}
        onWheel={onWheel}
        inputProps={{
          ...inputProps,
          "aria-describedby": `${Component.ErrorMessageId}${id}`,
          "aria-labelledby": ariaLabelledBy,
          maxLength: maxLength,
        }}
        multiline={multiline}
        rows={rows}
      />
      {((required && !selectedValue) || error) && (
        <div role="alert" aria-live="polite">
          <span id={`${Component.ErrorMessageId}${id}`} className={classes.errorText}>
            {errorMessage ||
              (label
                ? `${label.replace(Component.Star, "")} ${ErrorMessages.InputRequired}`
                : ErrorMessages.InputRequired)}
          </span>
        </div>
      )}
    </Box>
  );
};
